import { createSlice } from '@reduxjs/toolkit'

const dataSlice = createSlice({
  name: 'tableSearch/data',
  initialState: {
    loading: false,
    tableList: [],
    tableDetailsID: 0,
    token: null,
  },
  reducers: {
    updateTable: (state, action) => {
      state.tableList = action.payload
    },
    updateTableDetailsID: (state, action) => {
      state.tableDetailsID = action.payload
    },
    setToken: (state, action) => {
      state.token = action.payload
    },
  },
  // extraReducers: {
  //     [getUsersList.fulfilled]: (state, action) => {
  //         state.tableList = action.payload.data
  //         state.loading = false
  //     },
  //     [getUsersList.pending]: (state) => {
  //         state.loading = true
  //     },
  // }
})
export const { updateTable, updateTableDetailsID, setToken } = dataSlice.actions

export default dataSlice.reducer
